import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames'

export default function FocusOnMount({ children, hasOutline, className, ...rest }) {
    const ref = useRef();

    useEffect(() => {
        try {
            ref.current.focus();
        }
        catch {
            // Do nothing
        }
    }, []);

    return (
        <div
            data-component="FocusOnMount"
            className={cx('sarsa-focus-on-mount', className, {
                'visible-outline': hasOutline
            })}
            ref={ref}
            tabIndex="-1"
            {...rest}>
            {children}
        </div>
    );
}

FocusOnMount.propTypes = {
    /** Contents */
    children: PropTypes.node.isRequired,

    /** If true, the container will have a visible outline when focused */
    hasOutline: PropTypes.bool,

    /** Additional class added to the outer container */
    className: PropTypes.string
};

FocusOnMount.defaultProps = {
    hasOutline: false,
    className: undefined
};
